/**
 * Created by quikr on 7/12/16.
 */
import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Topnav from "../components/TopNavigation/TopHeader";
import * as actions from "../redux/actions/Authentication/authActions";
import * as emp_actions from "../redux/actions/empActions";
import * as employeeActions from "../redux/actions/Employee/employeeActions";
import * as constantActions from "../redux/actions/constantActions";
import EmployeeSS from "../components/joiningForm/EmployeeSS";
import Banner from "../components/common/Banner";
import Mainnav from "../components/TopNavigation/Mainnav";
import Footer from "../components/common/utils/Footer";
import {LinkContainer} from "react-router-bootstrap";
import Drawer from "material-ui/Drawer";
import MenuItems from "material-ui/MenuItem";
import Menu from "material-ui/Menu";
import AppBar from "material-ui/AppBar";
import {hashHistory} from "react-router";
import PeopleSearchHome from "../feature/hradmin/PeopleSearch/PeopleSearchHome";

let song;
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to
}
class HomePage extends React.Component {
  constructor() {
    super();
    this.state = {data: null, series: null, open: false, showHrAdmin: false};
    this.logout = this.logout.bind(this);
    this.getChartData = this.getChartData.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.saveMenuItem = this.saveMenuItem.bind(this);
    this.saveLeaveItem = this.saveLeaveItem.bind(this);
    this.menuItems = [];
    this.leaveItems = [];
    this.toggleAttendanceMenu = () => this.setState(({ attendanceMenu}) => ({
      attendanceMenu: !attendanceMenu,
    }));
    this.toggleLeaveMenu = () => this.setState(({ leaveMenu}) => ({
      leaveMenu: !leaveMenu,
    }));
  }

  getChartData(attendance) {
    let data = new Array();
    let series = new Array();
    attendance.map((attendanceData, index)=> {
      data[index] = new Array();
      let hrs = 0, mins = 0;
      if (attendanceData.totalWorkingHour != null) {
        hrs = parseInt(attendanceData.totalWorkingHour.substr(0, 2));
        mins = parseInt(attendanceData.totalWorkingHour.substr(3, 2));
      }
      data[index][0] = hrs + mins / 100;
      if (attendanceData.date != null)
        series[index] = attendanceData.date.substr(0, 6);
    });


    this.setState({data: data, series: series});
  }


  componentDidMount() {
    this.props.dispatch(employeeActions.getActiveEmployee());
    debugger;
    this.props.dispatch(actions.myQuikr());
    this.props.dispatch(emp_actions.store());
    this.props.dispatch(constantActions.store());
  }

  componentWillMount() {

      let empRoles = this.props.name[0];
      if(empRoles.hr) {
          if (empRoles.peopleSearch || empRoles.exits || empRoles.exitsFnF || empRoles.onBoarding ||
              empRoles.onBoardingExpected || empRoles.leave || empRoles.upload || empRoles.download || empRoles.ctcSplit || empRoles.abscond) {
              this.setState({ showHrAdmin: true}, function() { });
          }
      }

  }

  componentWillReceiveProps(props) {
    this.getChartData(props.state[0].attendance.attendance);
  }

  logout() {
    this.props.dispatch(actions.logOut());
  }

  refresh() {

    this.props.dispatch(employeeActions.getActiveEmployee());
  }

  changeBanner() {

  }

  handleToggle() {
    this.setState({open: !this.state.open});
  }

  handleClose() {
    this.setState({open: false, attendanceMenu: false, leaveMenu: false});
  }

  saveMenuItem(items) {
    this.menuItems = items;
  }

  saveLeaveItem(items) {
    this.leaveItems = items;
  }

  render() {
    const Auth = this.props.Auth;
    const emp_info = this.props.name;
    if (emp_info[0].status != 'J')
      return (
        <div >

          <div style={{"zIndex": '5'}}>

            <Topnav
              employees={this.props.employees}
              name={emp_info[0].name}
              logout={this.logout}
              handleToggle = {this.handleToggle}/>
            <Mainnav roles={this.props.Auth[0].roles} permission={this.props.name[0]}
                     isManager={this.props.name[0].manager} handleToggle = {this.handleToggle} handleClose = {this.handleClose}
                     saveMenuItem = {this.saveMenuItem} saveLeaveItem = {this.saveLeaveItem}/>
          </div>
          <Drawer
          style={{}}
          docked={false}
          width={250}
          openSecondary={false}
          open={this.state.open}
          onRequestChange={(open) => {
            this.setState({open});
            this.handleClose();
          }}
        >
          <AppBar
            style={{backgroundColor: '#5cb85c'}}
            title="Quikr HRMS" width={1000}/>
          <MenuItems
            primaryText="Home"
            onTouchTap={this.handleClose}
            leftIcon={<img src="/public/images/home.svg"/> }
            onClick={()=> {
              hashHistory.push("/1/home");
              this.handleClose();

            }}
          />
          <MenuItems
            primaryText="Attendance"
            rightIcon={<img src="/public/images/next.svg"/>}
            onClick={this.toggleAttendanceMenu}
          />
          {this.state.attendanceMenu && this.menuItems}
          <MenuItems
            primaryText="Leave"
            rightIcon={<img src="/public/images/next.svg"/>}
            onClick={this.toggleLeaveMenu}
          />
          {this.state.leaveMenu && this.leaveItems}
          <MenuItems
            primaryText="My Profile"
            onTouchTap={this.handleClose}
            onClick={()=> {
              hashHistory.push("/1/myProfile");
              this.handleClose();
            }}
          />
          <MenuItems
            primaryText="Internal Tools"
            onTouchTap={this.handleClose}
            onClick={()=> {
              hashHistory.push("/1/applicationAccess");
              this.handleClose();
            }}
          />
          <MenuItems
            primaryText="My Reporting"
            onTouchTap={this.handleClose}
            onClick={()=> {
              hashHistory.push("/1/myReporting");
              this.handleClose();
            }}
          />

          <MenuItems
            primaryText="Policies"
            onTouchTap={this.handleClose}
            onClick={()=> {
              hashHistory.push("/1/policy");
              this.handleClose();

            }}
          />
          {this.state.showHrAdmin ? <MenuItems
            primaryText="HR Admin"
            onTouchTap={this.handleClose}
            onClick={()=> {
              hashHistory.push("/1/admin");
              this.handleClose();

            }}
          /> : null}
          {this.props.name[0].it ? <LinkContainer to="/1/it">
            <MenuItems
              primaryText="IT Admin"
              onTouchTap={this.handleClose}
              onClick={()=> {
                hashHistory.push("/1/it");
                this.handleClose();

              }}
            />
          </LinkContainer> : null}
          {this.props.name[0].admin ? <LinkContainer to="/1/administrator">
            <MenuItems
              primaryText="Facilities"
              onTouchTap={this.handleClose}
              onClick={()=> {
                hashHistory.push("/1/administrator");
                this.handleClose();

              }}
            />
          </LinkContainer> : null}
          {this.props.name[0].finance ? <LinkContainer to="/1/finance">
            <MenuItems
              primaryText="Finance"
              onTouchTap={this.handleClose}
              onClick={()=> {
                hashHistory.push("/1/finance");
                this.handleClose();

              }}
            />
          </LinkContainer> : null}


          <Menu>

          </Menu>
        </Drawer>
          <div>
            {React.cloneElement(this.props.children, {
              refresh: this.refresh,
              roles: Auth[0].roles,
              name: emp_info[0].name,
              emp: emp_info[0],
              data: this.state.data,
              series: this.state.series,
              empRoles:emp_info[0]
            })}
          </div>
        </div>);
    else return <div className="col-md-12">
      <div className="col-md-1"></div>
      <div style={{backgroundColor: 'white', marginBottom: '30', paddingBottom: '20'}} className="col-md-10">
        <Banner name="Welcome to QUIKR"/>

        <div className="col-md-12">
          <EmployeeSS
            showAll={true}
            changeBanner={this.changeBanner} employee={this.props.name[0]}/></div>
      </div>
      <div className="col-md-1">
      </div>
      <Footer /></div>

  }

  componentWillUnmount() {

  }

}
HomePage.propTypes = {
  name: PropTypes.array.isRequired,
  Auth: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired


};

function mapStateToProps(state, ownProps) {
  return {
    Auth: state.auth,
    name: state.emp,
    state: state.attendance,
    employees: state.employees,
  };

}

export default connect(mapStateToProps)(HomePage);





/** WEBPACK FOOTER **
 ** ./src/containers/MainPage.js
 **/